import { useState } from "react";
import { Wand2 } from "lucide-react";
import { useBookEditor } from "./BookEditorProvider";

/** Turn 1 floating AI entry — structured commands arrive in Turn 7. */
export default function BookEditorAI() {
  const { mode, activeChapter, selection } = useBookEditor();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="book-editor-ai-fab"
        data-testid="book-editor-ai-fab"
        title="Ask Book AI"
        aria-label="Open Book AI"
        onClick={() => setOpen((v) => !v)}
      >
        <Wand2 size={18} />
      </button>
      {open && (
        <div className="book-editor-ai-panel" data-testid="book-editor-ai-panel">
          <header>
            <strong>Book AI</strong>
            <button type="button" onClick={() => setOpen(false)}>Close</button>
          </header>
          <p>
            Context: {mode} mode
            {activeChapter ? ` · ${activeChapter.title}` : ""}
            {selection?.ids?.length ? ` · ${selection.ids.length} selected` : ""}
          </p>
          <p className="book-editor-hint">
            AI will emit structured editor commands (preview / apply / undo) in Turn 7.
            It will not mutate MongoDB directly.
          </p>
        </div>
      )}
    </>
  );
}
